import {
  mergeConfig,
  wrapAsDerivedFromMeasurementsConfig as wrap,
} from 'Components/Worksheets/Core/Helpers/configHelpers';
import getMoistureContentDerivedFromMeasurementsConfig from 'Components/Worksheets/MoistureContentWorksheet/derivedFromMeasurementsConfig';

const getDerivedFromMeasurementsConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Masses.InitialWetMass`]: wrap([
        `${prefix}.Masses.InitialTareMass`,
        `${prefix}.Masses.InitialTareAndWetMass`,
      ]),
      [`${prefix}.Masses.InitialDryMass`]: wrap([
        `${prefix}.Masses.InitialTareMass`,
        `${prefix}.Masses.InitialTareAndDryMass`,
      ]),
      [`${prefix}.Masses.WashedDryMass`]: wrap([
        `${prefix}.Masses.InitialTareMass`,
        `${prefix}.Masses.WashedTareAndDryMass`,
      ]),
      [`${prefix}.Masses.WashingsDryMass`]: wrap([
        `${prefix}.Masses.InitialTareAndDryMass`,
        `${prefix}.Masses.WashedTareAndDryMass`,
      ]),
    },
    getMoistureContentDerivedFromMeasurementsConfig(`${prefix}.Masses.MeasuredWashedConstantDryMass`)
  );

export default getDerivedFromMeasurementsConfig;
